import api from "./axios";

class ServiceCheckCostCenter {
  async save(costCenter) {
    const { data } = await api.post("/check-cost-centers", costCenter);
    return data;
  }

  async update(costCenter) {
    await api.put(`/check-cost-centers/${costCenter.id}`, costCenter);
  }

  async delete(id) {
    await api.delete(`/check-cost-centers/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/check-cost-centers/${id}`);
    return data;
  }

  async findAll() {
    const { data } = await api.get("/check-cost-centers");
    return data;
  }
}

export default new ServiceCheckCostCenter();
